<template>
  <button
    type="button"
    class="aha-icon-button"
    @click="$emit('click', $event)"
    :class="[
      `aha-icon-button--${size}`,
      `aha-icon-button--${variant}`,
      {'active': isActive}
    ]"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'tertiary',
    },
    size: {
      type: String,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-icon-button {
  /* prevent the text inside the button from flicking */
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  @apply border-transparent inline-flex items-center justify-center;
  transition: 0.2s ease-in-out;
  outline: none;
}

// VARIANT
.aha-icon-button--tertiary {
  @apply bg-transparent;
  &:hover:not(:active):not(:disabled) {
    background-color: #E0E3ED;
  }
  &.active {
    background-color: #D3D6E0;
  }
  &:focus:not(.active):not(:disabled) {
    @apply border-primary-80;
    box-shadow: 0px 0px 0px 2px #89BEFA;
  }
  &[disabled] {
    @apply cursor-not-allowed text-base-65;
  }
}

.aha-icon-button--tertiary-dark {
  @apply bg-transparent;
  color: #fff;
  &:hover:not(:active):not(:disabled) {
    background-color: #232323;
  }
  &.active {
    background-color: #3b3b3b;
  }
  &:focus:not(.active):not(:disabled) {
    @apply border-primary-80;
    box-shadow: 0px 0px 0px 2px #89BEFA;
  }
  &[disabled] {
    @apply cursor-not-allowed text-base-65;
  }
}

.aha-icon-button--secondary {
  @apply bg-base-0;
  border: 1px solid;
  border-color: #D3D7E1;
  &:hover:not(:active):not(:disabled) {
    background-color: #F2F7FF;
    border-color: #2E7FDB;
  }
  &.active {
    background-color: #D8E9FD;
    border-color: #2970C2;
  }
  &:focus:not(.active):not(:disabled) {
    border: 2px solid #89BEFA;
    box-shadow: 0px 0px 0px 2px #89BEFA;
  }
  &[disabled] {
    @apply cursor-not-allowed text-base-65;
  }
}

// SIZE
.aha-icon-button--xs {
}

.aha-icon-button--sm {
  @apply p-1 rounded border;
}

.aha-icon-button--md {
  @apply p-2 rounded-lg border-2;
}

.aha-icon-button--lg {
}

.aha-icon-button--xl {
}

.aha-icon-button--2xl {
}
</style>
